<template>
  <div class="storage">
    <p class="table--records">
      Records found {{ records }}      
    </p>

    <slot/>
    
    <div class="storage--pagination">
      <Pagination 
        :pages="pages"
        v-on:handleLeftButton="$emit('handleLeftButton')"
        v-on:handleRightButton="$emit('handleRightButton')"
      />
    </div>    
  </div>
</template>

<script>
  import Pagination from '../buttons/pagination.vue'

  export default {
    name: 'ImagesComponent',
    props: [
      'records',
      'pages'
    ],
    components: {
      Pagination
    }
  }
</script>

<style lang="scss">
  .storage {
    background-color: var(--white);
    padding: 15px;
    border-radius: 3px;
    margin-top: 15px;
    width: 100%;
    float: left;

    .row-small {
      margin-top: 15px;

      .ratio {
        margin-bottom: 15px;
        border-radius: 1px;
        overflow: hidden;
        border: 1px solid var(--grey-light);
      }
    }

    &--pagination {
      overflow: hidden;
      display: flex;
      justify-content: center;
    }
  }
</style>